<template>
  <div class="who-section">
    <div class="who-inner">
      <div class="who-header">
        <h2 class="who-title reveal">Who We're<br />Looking For</h2>
        <p class="who-subtitle reveal">
          Creators of all sizes — united by a love for fashion.
        </p>
      </div>
      <div class="who-grid">
        <div
          v-for="(card, i) in cards"
          :key="card.name"
          class="who-card reveal"
          :class="i > 0 ? 'reveal-delay-' + i : ''"
        >
          <span class="who-card-num">{{ card.num }}</span>
          <h3 class="who-card-name">{{ card.name }}</h3>
          <p class="who-card-desc">{{ card.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkWithUsCards",
  props: {
    cards: {
      type: Array,
      default: () => [
        {
          num: "01",
          name: "Influencers",
          desc: "Social media creators with an engaged audience who love sharing their personal style and inspiring their followers through authentic content.",
        },
        {
          num: "02",
          name: "Content Creators",
          desc: "Photographers, videographers, stylists and digital creators who bring brands to life through compelling visual storytelling.",
        },
        {
          num: "03",
          name: "Fashion Enthusiasts",
          desc: "Style-forward individuals with a genuine passion for designer eyewear who want to be part of something real — not just a sponsored post.",
        },
      ],
    },
  },
};
</script>
